import httpClient from '../httpClient';
import { PhoneNumber, User } from '../../models/User';
import managers from './managers';
import admins from './admins';

const authPath = (routePath: TemplateStringsArray) => `auth/${routePath}`;

function getCurrentUser() {
  return httpClient.get<User>('users/current');
}

function patchUser(user: Partial<User>) {
  return httpClient.patch<User>('users', user);
}

function changePhoneNumber(phoneNumber: PhoneNumber) {
  return httpClient.post('users/phone-number', phoneNumber);
}

function updatePassword(oldPassword: string, newPassword: string) {
  return httpClient.patch(authPath`change-password`, {
    oldPassword,
    newPassword,
  });
}

function updateEmail(email: string) {
  return httpClient.post('users/change-email', { email });
}

function verifyEmail(token: string) {
  return httpClient.post(`users/verify-email/${token}`);
}

export default {
  getCurrentUser,
  patchUser,
  changePhoneNumber,
  updatePassword,
  updateEmail,
  verifyEmail,
  managers,
  admins,
};
